import { ActionTree } from "vuex";
import { StateInterface } from "src/store";
import { SessionsUtilsStateInterface } from "./state";
import LocalDb from "src/services/db";
import { SessionState, SessionLastState } from "./models";

const actions: ActionTree<SessionsUtilsStateInterface, StateInterface> = {
  async getSessionState(
    context,
    payload: { session_guid: string }
  ): Promise<SessionState> {
    // console.log("getSessionState payload", payload);
    if (!context.state.session_state[payload.session_guid]) {
      const db = await LocalDb;
      const session_state = await db.cache.getByKey(
        `session_state[${payload.session_guid}]`
      );
      await context.dispatch("setSessionState", {
        session_guid: payload.session_guid,
        ...session_state,
      });
    }
    return context.state.session_state[payload.session_guid] ?? {};
  },

  async setSessionState(
    context,
    payload: { session_guid: string; last_state?: SessionLastState }
  ): Promise<any> {
    // console.log("setSessionState payload", payload);
    if (payload.last_state) {
      context.commit("setSessionLastState", {
        session_guid: payload.session_guid,
        last_state: payload.last_state,
      });
    }
    const db = await LocalDb;
    await db.cache.put(
      `session_state[${payload.session_guid}]`,
      context.state.session_state[payload.session_guid] ?? {}
    );

    return Promise.resolve();
  },
};

export default actions;
